module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Music-note-4f3720e49a30e86611062c0b9e9df119.svg";